module.exports = __webpack_public_path__ + "img/仰之弥高.3ad54f34.png";